module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/logo_serasa_credito_rosa-198ed0aa0bc1a5b5bcfe0a363e626a93.webp";